var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tdb-dealroom-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Funding Areas")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/deals/platforms/tdb-health-dealroom",
            text: "Health",
            caption: "Healthcare and pharmaceuticals",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/deals/platforms/tdb-health-dealroom")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/deals/platforms/tdb-infrastructure-dealroom",
            text: "Infrastructure",
            caption: "Infrastructure and utilities",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick(
                "/deals/platforms/tdb-infrastructure-dealroom"
              )
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/deals/platforms/tdb-climate-dealroom",
            text: "Climate",
            caption: "Climate and environment",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick(
                "/deals/platforms/tdb-climate-dealroom"
              )
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }